import { ReactNode } from 'react';
import { styled } from 'styled-components';
import {
  Card,
  Divider,
  HStack,
  RadioButton,
  VStack,
} from '@vivaahealth/design-system';
import type { RadioButtonProps } from '@vivaahealth/design-system/dist/components/Input/RadioButton/RadioButton';

const StyledBaseCard = styled(Card)`
  .ds-card__body {
    padding-top: 0;
  }
`;

interface Props {
  radioButtonProps: RadioButtonProps;
  cardBody: ReactNode | null;
  headerCta?: ReactNode;
}

export const RadioButtonCard = ({
  radioButtonProps,
  cardBody,
  headerCta,
}: Props) => {
  const { checked, label, name, onChange } = radioButtonProps;

  return (
    <StyledBaseCard>
      <Card.Header>
        <HStack width="100%" justifyContent="space-between" alignItems="center">
          <RadioButton
            checked={checked}
            label={label}
            name={name}
            onChange={onChange}
          />
          {checked && (headerCta || null)}
        </HStack>
      </Card.Header>
      {checked && cardBody && (
        <Card.Body>
          <VStack width="100%" gap={12}>
            <Divider />
            {cardBody}
          </VStack>
        </Card.Body>
      )}
    </StyledBaseCard>
  );
};
